import NotificationCenter from 'view_models/common/notification_center/module';
import NotificationListItem from 'libs/components/notifications/list-item';

if (WEBSOCKET_HOST && WEBSOCKET_HOST.length > 0) {
  const protocol = (RAILS_ENV == 'development' ? 'ws' : 'wss');

  Kadenze.WebSocket = io(protocol + '://' + WEBSOCKET_HOST + '/kadenze');

  const userConnected = function() {
    const uid = $('body').data('uid');

    if (!uid)
      return false;

    Kadenze.WebSocket.emit('add_user', {uid: uid, location: document.location.toString()});

    new Kadenze.AjaxRequest({type: 'POST', url: Kadenze.Routes.presence_index_path()});
  };

  Kadenze.WebSocket.on('connect', function(){
    console.log('Connected to websocket.');
    userConnected();
  });

  Kadenze.WebSocket.on('notification_create', function(msg){
    const data = JSON.parse(msg);
    const $notificationCenter = $('[data-notification-lists="updates"]').first();
    const vm = $notificationCenter.data().VM;
    const notificationListItem = new NotificationListItem(data);
    const list = vm.itemLists()[0];

    list.items.unshift(notificationListItem);
    list.tallyFreshItems(list.items());
    vm.tallyAllFreshItems();
  });

  Kadenze.WebSocket.on('messenger_conversation_updated', function(){
    const $notificationCenter = $($('[data-module-amd="CommonNotificationCenter"]')[2]);

    NotificationCenter.refresh($notificationCenter[0]);
  });
} else {
  console.warn('[Websocket] WEBSOCKET_HOST not defined - skipping connection');
}
